// const { hostname } = document.location;

export const config = {
  api: {
    prefix: '/custom',
    timeout: 20000,
  },
  ws: {
    url: document.location.hostname,
  },
  debug: {
    logger: true,
    beacon: false,
  },
};
